module.exports = __webpack_public_path__ + "img/a604048.jpg";